import 'simplebar';
import {debounce, throttle} from 'lodash';
import $ from 'jquery';

export default {

  _bindEvents() {
    let throttledScroll = _.throttle(this.hasScrolled.bind(this), 200);
    $('.blog-reel__articles-wrapper .simplebar-content-wrapper').on('scroll', throttledScroll);
    window.addEventListener('popstate', throttledScroll.cancel);
  },

  init() {
    this._bindEvents();
    this.toggleScrollIndicator();
  },

  hasScrolled() {
    this.toggleScrollIndicator();
  },

  toggleScrollIndicator() {
    $('.blog-reel__articles-wrapper .simplebar-content-wrapper').each( function() {
      const outerWidth = $(this).outerWidth();
      const scrollPos = $(this).scrollLeft();
      const scrollWidth = $(this)[0].scrollWidth;
      const scrollDiff = scrollWidth - (outerWidth + scrollPos);
      console.log(scrollDiff);

      if ( scrollDiff < 100 ) {
        $(this).closest('.blog-reel__articles-wrapper').find('.blog-reel__scroll-indicator').css('display','none');
      } else {
        $(this).closest('.blog-reel__articles-wrapper').find('.blog-reel__scroll-indicator').css('display','block');
      }
    });
  }
}
